import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { getRaceFieldFormDataFromApi, GetRaceFieldFormDataParams } from './api'

export const useRaceFieldFOOFormData = (raceFieldFOOFormData: GetRaceFieldFormDataParams) =>
  useQuery({
    queryKey: [
      queryKeys.racePageFieldFOOForm(
        raceFieldFOOFormData.racecourseSeq,
        raceFieldFOOFormData.meetingDate,
        raceFieldFOOFormData.raceNumber
      ),
    ],
    queryFn: () => getRaceFieldFormDataFromApi(raceFieldFOOFormData),
    staleTime: Infinity,
    gcTime: 0,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!raceFieldFOOFormData.racecourseSeq && raceFieldFOOFormData.raceNumber !== null,
  })
